import styled from 'styled-components'

export const ApproachContainer = styled.div`
  margin-bottom: 20px;

  .therapyApproachSelect {
    max-width: initial !important;
    > div {
      margin-top: 0;
    }
  }
`

export const ApproachWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`